import * as OSPModule from 'sankeyanimation/dist/src/OSPModule';
export const OSPInitializeApplicationData = OSPModule.OSPInitializeApplicationData;
export const OSPInitalizeSelectorDetailNodes = OSPModule.OSPInitalizeSelectorDetailNodes;
